module.exports = __webpack_public_path__ + "static/media/logged_background.bdbd637f.png";